import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-Discount-arrow-24",
  "use": "ico-Discount-arrow-24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-Discount-arrow-24\">\n<path d=\"M18 11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11L16 14.5858C16 14.5858 10.6005 9.18054 10.21 8.79001C9.81948 8.39949 9.18052 8.39951 8.79 8.79004C8.39948 9.18056 8.39948 9.81948 8.79 10.21L14.5858 16H11C10.4477 16 10 16.4477 10 17C10 17.5523 10.4477 18 11 18H17C17.5523 18 18 17.5523 18 17V11Z\" fill=\"#C21F3A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol